import React from 'react';
import { logger } from '../utils/logger';

export default class AppErrorBoundary extends React.Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Keep the stack available to the existing browser monitoring pipeline.
    // Do not include auth/session data in diagnostics.
    logger.error('Unhandled UI error', error, errorInfo);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <main className="app-error-boundary" role="alert">
        <h1>Something went wrong</h1>
        <p>The dashboard could not render this view. Reload the page to try again.</p>
        <button type="button" onClick={this.handleReload}>
          Reload page
        </button>
      </main>
    );
  }
}
